/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import _ from 'lodash';
import queryString from 'query-string';

import moment from 'moment';
import { convertStringToNumber } from '../../../helpers/numbers';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

import { filterBy, process as kendoProcess } from '@progress/kendo-data-query';
import { BooleanFilter, DateFilter, NumericFilter, Operators, TextFilter } from '@progress/kendo-react-data-tools';
import { Grid, GridColumn as Column, GridNoRecords, GridToolbar, GridColumnMenuWrapper } from '@progress/kendo-react-grid';
import BobLoadingMask from '../../../components/BobLoadingMask';
import { Mixpanel } from '../../../helpers/mixpanel';

import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/styles';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import BooleanCellFilter from '../../../components/CustomFilters/BooleanCellFilter';
import FormulaGridColumnModal from '../../../components/FormulaGridColumnModal';
import FilterPanel from '../../../components/K2AFilterControl/FilterPanel';

import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import SensorScoreAggregateFooterCell from '../../../components/SensorScoreAggregateFooterCell';
import ConditionalFormatModal from '../Modals/ConditionalFormatModal';

import * as BobActions from '../../../actions/bobActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import * as classes from './ScoreGrid.module.css';

const MIXPANEL_EVENT = 'Equipment Score Grid';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white',
        color:           'black',
        fontSize:        theme.typography.pxToRem(20),
        border:          '1px solid grey',
        borderRadius:    '5px',
        maxWidth:        '500px'
    }
}))(Tooltip);

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const booleanCellFilterValues = [{ text: 'In Fault', operator: 'eq', value: true }, { text: 'No Fault', operator: 'eq', value: false }];
const defaultItem = { text: '(All)', operator: '' };

const FaultCellFilter = (props, selectedBooleanFilter, setSelectedBooleanFilter) => {
    return (
        <BooleanCellFilter
            {...props}
            data={booleanCellFilterValues}
            defaultItem={defaultItem}
            filterValue={selectedBooleanFilter}
            setFilterValue={setSelectedBooleanFilter}
        />
    );
};

const ScoreGrid = ({
    activeNavClient,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    activeConfiguration,
    aggregateType,
    axes,
    bobLoading,
    configuration,
    currentUser,
    setConfiguration,
    clearEntitySensorData,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    entityScoringData,
    entityScoringDataMeta,
    fetchEntitySensorData,
    fetchScoringData,
    fetchSensorIds,
    formulaGridColumns,
    history,
    ruleGridDataState,
    ruleGridFilterText,
    ruleGridFilter,
    ruleGridFields,
    ruleScoreKpis,
    ruleScoringConfig,
    scoreGridDataState,
    scoreGridFilter,
    scoreGridFilterText,
    scoreGridFields,
    selectedRule,
    setAggregateType,
    setActiveConfiguration,
    setRuleScoringConfiguration,
    selectedRuleSensors,
    selectedRuleFromFaultsPage,
    selectedWeatherSensors,
    setFormulaGridColumns,
    setRuleGridDataState,
    setRuleGridFilterText,
    setRuleGridFilter,
    setRuldGridFields,
    setSelectedRule,
    setSelectedRuleFromFaultsPage,
    setSelectedRuleSensors,
    setSelectedWeatherSensors,
    setScoreGridDataState,
    setScoreGridFilter,
    setScoreGridFilterText,
    setScoreGridFields,
    workbookModeEnabled,
    ...props
}) => {

    const [columnNames, setColumnNames] = useState([]);
    const [exportColumnNames, setExportColumnNames] = useState([]);
    const [scoringData, setScoringData] = useState([]);
    const [ showModal, setShowModal ] = useState(false);
    const [formatObj,setFormatObj] = useState({});
    const [formatList,setFormatList] = useState([]);
    const [formatKey,setFormatKey] = useState('');
    const [formatType,setFormatType] = useState('');

    const [formulaCellModalOpen, setFormulaCellModalOpen] = useState(false);
    const [formulaColumns, setFormulaColumns] = useState([]);
    const [formulaColumnIndex, setFormulaColumnIndex] = useState(0);
    const [formulaValues, setFormulaValues] = useState(null);
    const [currentFormula, setCurrentFormula] = useState(null);
    const [selectedBooleanFilter, setSelectedBooleanFilter] = useState(defaultItem);
    const [ruleInfo, setRuleInfo] = useState({});

    const queryValues = queryString.parse(history.location.search);
    const _export = useRef(null);
    const scoreGridRef = useRef(null);
    const [ firstRender, setFirstRender ] = useState(false);
    const styleMap = {
        'yellow-cell': {background: '#ffefaf',color: '#783f05'},
        'green-cell':  {background: '#b7e1cd',color: '#274e13'},
        'grey-cell':   {background: '#d9d9d9',color: '#434343'},
        'red-cell':    {background: '#fcd6d6',color: '#85200c'}
    };

    useEffect(() => {
        if (activeNavEquipment && activeNavEquipment.id && selectedRule && selectedRule.ruleId) {
            Mixpanel.track(MIXPANEL_EVENT, {
                company:   activeNavCompany.name,
                client:    activeNavClient.name,
                site:      activeNavSite.name,
                equipment: activeNavEquipment.name,
                userName:  `${currentUser.firstName} ${currentUser.lastName}`,
                email:     currentUser.email,
                rule:      selectedRule.ruleName
            });
        }
    }, [activeNavEquipment, selectedRule]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            setRuleGridDataState({...ruleGridDataState, filter: initialDataStateFilter});
            setScoreGridDataState({...scoreGridDataState, filter: initialDataStateFilter});
            setRuleGridFilterText('');
            setScoreGridFilterText('');
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init =  () => {
            setScoreGridFilter(initialDataStateFilter);
            setScoreGridFilterText('');

            const viewData = activeConfiguration.viewData;
            viewData.workbookMode = viewData.workbookMode || false;

            // score grid columns, conditionalFormat data from saved configuration
            setFormatObj(viewData.conditionalFormat || {});
            setColumnNames(viewData.columns || []);
            setFormulaColumns(viewData.selectedFormulaColumns || []);
            setFormulaGridColumns(viewData.selectedFormulaColumns || []);
            setAggregateType(viewData.aggregateType || 'None');

            const tempScoreGridDataState = scoreGridDataState;
            tempScoreGridDataState.filter = viewData.filter || initialDataStateFilter;
            setScoreGridDataState(tempScoreGridDataState);

            if (!_.isEmpty(viewData.selectedSensors)) {
                setSelectedRuleSensors(viewData.selectedSensors);
                if (viewData.selectedWeatherSensors) {
                    setSelectedWeatherSensors(viewData.selectedWeatherSensors);
                }
                else {
                    setSelectedWeatherSensors([]);
                }
            }
        };

        if (!_.isEmpty(activeConfiguration)) init();
    },[activeConfiguration]);

    useEffect(() => {
        const configurationData = { ...configuration };
        configurationData.aggregateType = aggregateType;
        setConfiguration(configurationData);
    }, [aggregateType]);

    useEffect(() => {
        if (formulaValues) {
            addFormulaColumn(formulaValues);
        }
    }, [formulaValues]);

    const addFormulaColumn = formula => {
        const currentFormulaList = _.cloneDeep(formulaColumns);
        const foundColumn = currentFormulaList.find(c => c.fieldName === formula.fieldName);
        if (!foundColumn) {
            const newFormulaList = [...currentFormulaList, formulaValues];
            setFormulaColumns(newFormulaList);
            const newColumn = {
                name:       formulaValues.cellTitle,
                title:      formulaValues.cellTitle,
                field:      formulaValues.fieldName,
                filter:     'numeric',
                format:     '{0:n}',
                isFormula:  true,
                orderIndex: formulaValues.cellIndex
            };

            let columnList = [...columnNames, newColumn];
            let exportColumnList = [...exportColumnNames, newColumn];
            setColumnNames(columnList);
            setExportColumnNames(exportColumnList);
            configuration.columns = columnList;
            configuration.selectedFormulaColumns = newFormulaList;
            setConfiguration(configuration);
        }
        else {
            const index = currentFormulaList.findIndex(c => c.fieldName === formula.fieldName);
            currentFormulaList[index] = formula;

            // grid columns
            try {
                columnNames.find(c => c.field === formula.fieldName).name = formula.cellTitle;
                columnNames.find(c => c.field === formula.fieldName).title = formula.cellTitle;
            }
            catch {
                // no need to do anything
            }

            // export columns
            try {
                exportColumnNames.find(c => c.field === formula.fieldName).name = formula.cellTitle;
                exportColumnNames.find(c => c.field === formula.fieldName).title = formula.cellTitle;
            }
            catch {
                // no need to do antying
            }

            setFormulaColumns(currentFormulaList);
            configuration.columns = columnNames;
            configuration.selectedFormulaColumns = currentFormulaList;
            setConfiguration(configuration);
        }

        const dataSet = addFormulaToGridDataSet(formulaValues, formulaValues.fieldName, scoringData);
        setScoringData(dataSet);
    };

    const addFormulaToGridDataSet = (formula, fieldName, gridData) => {
        const newDataSet = _.cloneDeep(gridData);
        let formulaResult = 0;
        newDataSet.map(data => {
            switch (formula.operator.operator) {
                case '+':
                    formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                    break;
                case '-':
                    formulaResult = parseFloat(data[formula.columnOne.field]) - parseFloat(data[formula.columnTwo.field]);
                    break;
                case '*':
                    formulaResult = parseFloat(data[formula.columnOne.field]) * parseFloat(data[formula.columnTwo.field]);
                    break;
                case '/':
                    formulaResult = parseFloat(data[formula.columnOne.field]) / parseFloat(data[formula.columnTwo.field]);
                    break;
                default:
                    formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                    break;
            }
            return data[formula.fieldName] = formulaResult.toFixed(formula.precision);
        });
        return newDataSet;
    };

    useEffect(() => {
        let columns = [{ name: 'Timestamp', title: 'Timestamp', field: 'start', filter: 'date', locked: true }];
        let entityScoringDataCopy = _.cloneDeep(entityScoringData);

        if (selectedRule && selectedRule.ruleId && !_.isEmpty(entityScoringDataMeta)) {
            const info = entityScoringDataMeta.info.rules.find(r => r.id === selectedRule.ruleId);
            if (info) {
                setRuleInfo(info);
            }
        }
        else {
            setRuleInfo({});
        }
        
        if (!_.isEmpty(entityScoringDataCopy)) {

            // apply saved column order from configuration
            if (!_.isEmpty(activeConfiguration)) {
                if (configuration.selectedSensors && _.isEqual(activeConfiguration.viewData.selectedSensors, configuration.selectedSensors)) {

                    let orderedEntityScoringData = {};
                    let savedColumns = _.cloneDeep(activeConfiguration.viewData.columns.filter(c => c.isFormula !== true));

                    if (!_.isEmpty(savedColumns)) {
                        let tempColumns = _.cloneDeep(savedColumns.filter(sensor => sensor.name !== 'Timestamp'));
                        let tempScoringData = entityScoringData[0];

                        if (!_.isEmpty(selectedWeatherSensors)) {
                            selectedWeatherSensors.forEach(sensor => {
                                switch (sensor) {
                                    case 'temperature':
                                        if (!tempColumns.find(item => item.name === 'Temperature')) {
                                            tempColumns.push({name: 'Temperature', field: `sensorVal_${activeNavSite.address.postalCode + ':temp'}`, filter: 'numeric', locked: false });
                                        }
                                        break;
                                    case 'minTemperature':
                                        if (!tempColumns.find(item => item.name === 'Min Temperature')) {
                                            tempColumns.push({name: 'Min Temperature', field: `sensorVal_${activeNavSite.address.postalCode + ':tempmin'}`, filter: 'numeric', locked: false });
                                        }
                                        break;
                                    case 'maxTemperature':
                                        if (!tempColumns.find(item => item.name === 'Max Temperature')) {
                                            tempColumns.push({name: 'Max Temperature', field: `sensorVal_${activeNavSite.address.postalCode + ':tempmax'}`, filter: 'numeric', locked: false });
                                        }
                                        break;
                                    case 'humidity':
                                        if (!tempColumns.find(item => item.name === 'Humidity')) {
                                            tempColumns.push({name: 'Humidity', field: `sensorVal_${activeNavSite.address.postalCode + ':humidity'}`, filter: 'numeric', locked: false });
                                        }
                                        break;
                                    case 'pressure':
                                        if (!tempColumns.find(item => item.name === 'Pressure')) {
                                            tempColumns.push({name: 'Pressure', field: `sensorVal_${activeNavSite.address.postalCode + ':pressure'}`, filter: 'numeric', locked: false });
                                        }
                                        break;
                                    default:
                                        tempColumns.push({field: `sensorVal_${activeNavSite.address.postalCode + ':' + sensor}`, filter: 'numeric', locked: false });
                                        break;
                                }
                            });
                        }

                        tempColumns.forEach(item => {
                            let id = item.field.split('_');

                            if (item.field.startsWith('ruleVal')) {
                                orderedEntityScoringData[`ruleName_${id[1]}`] = item.name;
                                orderedEntityScoringData[`ruleVal_${id[1]}`] = tempScoringData[`ruleVal_${id[1]}`];
                            } else if (item.field === 'ruleFvo') {
                                orderedEntityScoringData[`ruleFvo}`] = item.name;
                                orderedEntityScoringData[`ruleFvo`] = tempScoringData[`ruleFvo}`];
                            } else if (item.field.startsWith('ruleFvoSensorVal')) {
                                orderedEntityScoringData[`ruleFvoSensorName_${id[1]}`] = item.name;
                                orderedEntityScoringData[`ruleFvoSensorVal_${id[1]}`] = tempScoringData[`ruleFvoSensorVal_${id[1]}`];
                            } else if (item.field.startsWith('sensorVal')) {
                                orderedEntityScoringData[`sensorName_${id[1]}`] = item.name.startsWith('*') ? item.name : `*${item.name}`;
                                orderedEntityScoringData[`sensorVal_${id[1]}`] = tempScoringData[`sensorVal_${id[1]}`];
                            }
                        });

                        let tempEntityScoringData = _.cloneDeep(entityScoringDataCopy[0]);

                        Object.keys(tempEntityScoringData).forEach(item => {
                            if (item) {
                                if (item.startsWith('ruleName') || item.startsWith('ruleVal') || 
                                item.startsWith('sensorName') || item.startsWith('sensorVal')) {
                                    delete tempEntityScoringData[item];
                                }
                            }
                        });

                        // entityScoringData object with column order
                        entityScoringDataCopy[0] = {
                            ...tempEntityScoringData,
                            ...orderedEntityScoringData
                        };
                    }
                }
            }

            // eslint-disable-next-line no-sequences
            const keys = Object.entries(entityScoringDataCopy[0]).sort().reduce( (o,[k,v]) => (o[k]=v,o), {} );
            const fvo = Object.keys(keys).find(k => k === 'ruleFvo');
            if (fvo) {
                let filterType = 'string';
                if (entityScoringDataCopy[0]['ruleFvo']?.toString().toLowerCase() === 'true' || entityScoringDataCopy[0]['ruleFvo']?.toString().toLowerCase() === 'false') {
                    filterType = 'boolean';
                }
                else if (!isNaN(entityScoringDataCopy[0]['ruleFvo'])) {
                    filterType = 'numeric';
                }
                columns.splice(1, 0, {
                    name:   'Formula Value Output',
                    title:  'Formula Value Output',
                    field:  'ruleFvo',
                    filter: filterType,
                    format: filterType === 'numeric' ? '{0:n}' : null,
                    fault:  false
                });
            }

            Object.keys(keys).forEach(item => {
                let id = item.split('_');
                id = id[1];
                if (item.startsWith('ruleName') || item.startsWith('ruleFvoSensorName') || item.startsWith('sensorName')) {
                    Object.keys(entityScoringDataCopy[0]).forEach(point => {
                        if (point === `RuleInfault_${ id }`) {
                            columns.splice(1, 0, {
                                name:   'Fault',
                                title:  'Fault',
                                field:  point,
                                filter: 'boolean',
                                fault:  true
                            });
                        }
                        else if (point === `ruleVal_${id}`) {
                            let filterType = 'numeric';
                            columns.splice(2, 0, {
                                name:   entityScoringDataCopy[0][item],
                                title:  entityScoringDataCopy[0][item],
                                field:  point,
                                filter: filterType,
                                format: filterType === 'numeric' ? '{0:n}' : null,
                                fault:  false
                            });
                        }
                        else if (point === `ruleFvoSensorVal_${ id }` || point === `sensorVal_${ id }`) {
                            let filterType = 'numeric';
                            if (point.includes('ruleVal') || point.includes('temp') || point.includes('humidity') || point.includes('pressure')) {
                                filterType = 'numeric';
                            }
                            else if (typeof entityScoringDataCopy[0][point] === 'boolean' ||
                                entityScoringDataCopy[0][point]?.toString().toLowerCase() === 'false' ||
                                entityScoringDataCopy[0][point]?.toString().toLowerCase() === 'true') {
                                filterType = 'boolean';
                            }
                            else if (!_.isNaN(entityScoringDataCopy[0][point])) {
                                filterType = 'numeric';
                            }
                            else if (_.isEmpty(entityScoringDataCopy[0][point]) || entityScoringDataCopy[0][point] === 'null') {
                                filterType = 'text';
                            }

                            columns.push({
                                name:   entityScoringDataCopy[0][item] ? entityScoringDataCopy[0][item] : 'Unknown Sensor',
                                title:  entityScoringDataCopy[0][item] ? entityScoringDataCopy[0][item] : 'Unknown Sensor',
                                field:  point,
                                filter: filterType,
                                format: filterType === 'numeric' ? '{0:n}' : null,
                                fault:  false
                            });
                        }
                    });
                }
            });

            // move the fault and fvo to postions 2 and 3
            const faultColumnIndex = columns.findIndex(c => c.field.startsWith('RuleInfault_'));
            if (faultColumnIndex !== -1) {
                const faultColumn = columns.splice(faultColumnIndex, 1)[0];
                columns.splice(1, 0, faultColumn);
            }
            const fvoColumnIndex = columns.findIndex(c => c.field === 'ruleFvo');
            if (fvoColumnIndex !== -1) {
                const fvoColumn = columns.splice(fvoColumnIndex, 1)[0];
                columns.splice(2, 0, fvoColumn);
            }

            if (formulaColumns) {
                formulaColumns.forEach(item => {
                    const foundColumn = columns.find(c => c.field === item.fieldName);
                    if (!foundColumn) {
                        columns.push({
                            name:       item.cellTitle,
                            title:      item.cellTitle,
                            field:      item.fieldName,
                            filter:     'numeric',
                            format:     '{0:n}',
                            isFormula:  true,
                            orderIndex: item.cellIndex
                        });
                    }
                });
            }

            // save selected columns in configuration
            configuration.columns = columns;
            if (!_.isEmpty(formulaColumns)) {
                configuration.selectedFormulaColumns = formulaColumns;
            }
            setConfiguration(configuration);

            entityScoringDataCopy.forEach(item => {
                Object.keys(item).forEach(obj => {
                    if (obj.includes('overallScore') || obj.includes('ruleVal')) {
                        if (item[obj] !== null) {
                            let value = item[obj] * 100;
                            value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;
                            item[obj] = value;
                        }
                    }
                    if (obj.startsWith('ruleFvoSensorVal') || obj.startsWith('sensorVal')) {
                        let convertedValue = null;
                        if (typeof item[obj] === 'string' && item[obj]?.toLowerCase() === 'true') {
                            convertedValue = true;
                        }
                        else if (typeof item[obj] === 'string' && item[obj]?.toLowerCase() === 'false') {
                            convertedValue = false;
                        }
                        else if (typeof item[obj] === 'boolean') {
                            convertedValue = item[obj];
                        }
                        else if (item[obj] === null) {
                            convertedValue = item[obj];
                        }
                        else if (!Number.isNaN(item[obj])) {
                            if (typeof item[obj] === 'number') {
                                convertedValue = item[obj];
                            } else {
                                convertedValue = convertStringToNumber(item[obj]);
                            }
                        }
                        else {
                            convertedValue = item[obj];
                        }
                        item[obj] = convertedValue;
                    }
                });
            });

        }

        const result = _.cloneDeep(entityScoringDataCopy);
        if (!_.isEmpty(formulaColumns)) {
            result.forEach(data => {
                let formulaResult = 0;
                formulaColumns.forEach(formula => {
                    formulaResult = 0;
                    switch (formula.operator.operator) {
                        case '+':
                            formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                            break;
                        case '-':
                            formulaResult = parseFloat(data[formula.columnOne.field]) - parseFloat(data[formula.columnTwo.field]);
                            break;
                        case '*':
                            formulaResult = parseFloat(data[formula.columnOne.field]) * parseFloat(data[formula.columnTwo.field]);
                            break;
                        case '/':
                            formulaResult = parseFloat(data[formula.columnOne.field]) / parseFloat(data[formula.columnTwo.field]);
                            break;
                        default:
                            formulaResult = parseFloat(data[formula.columnOne.field]) + parseFloat(data[formula.columnTwo.field]);
                            break;
                    }
                    return data[formula.fieldName] = formulaResult.toFixed(formula.precision);
                });

            });
        }

        setScoringData(result);
        setColumnNames(columns);
        setExportColumnNames(columns);
    }, [entityScoringData]);

    useEffect(() => {
        const columns = columnNames.map(column => {
            const filterType = column.filter === 'text' ? TextFilter : column.filter === 'numeric' ? NumericFilter : column.filter === 'date' ? DateFilter : BooleanFilter;
            const operatorList = column.filter === 'text' ? Operators.text : column.filter === 'numeric' ? Operators.numeric : column.filter === 'date' ? Operators.date : Operators.boolean;
            return {
                name:      column.field,
                label:     column.title ? column.title : column.name,
                filter:    filterType,
                operators: operatorList
            };
        });
        setScoreGridFields(columns);
    }, [columnNames]);

    const timeStampCell = props => {
        const conditions = formatObj['start'];
        let _className = '';
        const datatype = 'date';
        let zone = moment.tz.guess();
        let fd =  moment(props.dataItem.start).format('YYYY-MM-DD h:mm A');
        const timeDisplay = fd + ' ' + getTimeZoneAbbr(props.dataItem.start, zone);
        if (conditions && props.dataItem['start'] !== null && props.dataItem['start'] !== '' && props.dataItem['start'] !== undefined) {
            _className = parseCondition(conditions, fd, datatype);
        }
        return (
            <td className={`${props.className} ${_className}`} style={props.style}>
                {timeDisplay}
            </td>
        );
    };

    const getStyle = (condition) => {
        if (!condition) {
            return '';
        }
        else if (condition.indexOf('Yellow') !== -1) {
            return 'yellow-cell';
        }
        else if (condition.indexOf('Green') !== -1) {
            return 'green-cell';
        }
        else if (condition.indexOf('Grey') !== -1) {
            return 'grey-cell';
        }
        else if (condition.indexOf('Red') !== -1) {
            return 'red-cell';
        }
        else return '';
    };

    const getBoolean = (val)=>{
        return String(val)?.toLowerCase() === 'true';
    };


    useEffect(() => {
        if (props.refresh && firstRender) {
            handleExport();
        }
        setFirstRender(true);
    }, [props.refresh]);

    const handleExport = event => {
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach((row,rindex) => {
            if (row.type === 'data') {
                row.cells.forEach((cell,colindex) => {
                    if (colindex === 0) {
                        formatTimeStampCell(cell);
                    }
                    else formatDataCell(cell,colindex);
                });
            }
        });
        _export.current.save(options);
    };

    const formatTimeStampCell = (cell) => {
        const conditions = formatObj['start'];
        let _className = '';
        const datatype = 'date';
        let zone = moment.tz.guess();
        let fd = moment(cell.value).format('YYYY-MM-DD h:mm A');
        const timeDisplay = fd + ' ' + getTimeZoneAbbr(cell.value, zone);
        if (conditions && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            _className = parseCondition(conditions, fd, datatype);
        }
        if (_className) {
            cell.background = styleMap[_className].background;
            cell.color = styleMap[_className].color;
        }
        cell.value = timeDisplay;
    };

    const formatDataCell = (cell,colindex) => {
        const field = exportColumnNames[colindex].field;
        const conditions = formatObj[field];
        let _className = '';
        const datatype = exportColumnNames[colindex].filter;
        if (conditions && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            _className = parseCondition(conditions, cell.value, datatype);
        }
        if (_className) {
            cell.background = styleMap[_className].background;
            cell.color = styleMap[_className].color;
        }
        if (datatype === 'numeric') {
            cell.format = '#,###,##0.##########';
        }
    };

    const parseCondition = (conditions, value, datatype) => {
        let style = '';
        if (datatype === 'numeric') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (Number(value) > c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (Number(value) < c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (Number(value) === c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((Number(value) >= c.field1 && Number(value) <= c.field2) || (Number(value) <= c.field1 && Number(value) >= c.field2)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'boolean') {
            conditions.forEach(c => {
                if (c.operator === 'Equals') {
                    if (getBoolean(value) === getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (getBoolean(value) !== getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'date') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (new Date(value).getTime() > new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (new Date(value).getTime() < new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (new Date(value).getTime() === new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((new Date(value).getTime() >= new Date(c.field1).getTime() && new Date(value).getTime() <= new Date(c.field2).getTime()) ||
                    (new Date(value).getTime() <= new Date(c.field1).getTime() && new Date(value).getTime() >= new Date(c.field2).getTime())) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else   if (datatype === 'string' || datatype === 'text') {
            conditions.forEach(c => {
                if (c.operator === 'Contains') {
                    if (value.indexOf(c.field1) !== -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not contain') {
                    if (value.indexOf(c.field1) === -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (value === c.field1 ) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (value !== c.field1 ) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Starts with') {
                    if (value.startsWith(c.field1 )) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Ends with') {
                    if (value.endsWith(c.field1 )) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        return style;
    };

    const valueCell = props => {
        const { dataItem, field } = props;
        const conditions = formatObj[field];
        let className = '';
        const datatype = columnNames.filter(c => c.field === field)[0].filter;
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            className = parseCondition(conditions,dataItem[field],datatype);
        }

        if (field) {
            if (field.startsWith('ruleName')) {
                let value = props.dataItem[field];
                if (props.dataItem[field] !== null) {
                    value = props.dataItem[field];
                }

                return (
                    <td style={{ textTransform: 'capitalize' }} className={className}>
                        {(value !== null && value !== 'null' && value !== '' && value !== undefined) ? value : ''}
                    </td>
                );
            } else if (field === 'ruleFvo') {
                let fvoValue = dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined ? dataItem[field].toString() : 'No Data';
                if (!isNaN(fvoValue) && fvoValue?.toLowerCase() !== 'true' && fvoValue?.toLowerCase() !== 'false') {
                    fvoValue = Math.round(_.toNumber(fvoValue) * 10000) / 10000;
                }
                return (
                    <td style={{ textTransform: 'capitalize' }} className={className}>
                        {fvoValue}
                    </td>
                );
            } else {
                return (
                    <td style={{ textTransform: 'capitalize' }} className={className}>
                        {(dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) ? 
                            dataItem[field].toString() === 'Poll Failure' ? dataItem[field].toString() :
                                dataItem[field].toString() : 'No Data'}
                    </td>
                );
            }
        }
        else {
            return '';
        }
    };

    const ruleScoreCell = props => {
        const { field } = props;
        let value = props.dataItem[field];
        value = value !== null && value !== '' ? value.toString().includes('.') ? parseFloat(value).toFixed(2) : value : '';

        const colorClass = value === null ? classes.NoColorvalue : value > 74 ? classes.Green : value > 49 ? classes.Yellow : value >= 0 ? classes.Red : classes.NoColor;
        return (
            <td className={clsx(props.className, classes.NameCell, colorClass)} style={props.style}>
                {value}
            </td>
        );
    };

    const ColumnMenu = (props) => {

        const createConditionalFormat =()=>{
            props.onCloseMenu();
            let formats = [];
            if (formatObj[props.column.field]) {
                formats = formatObj[props.column.field];
            }
            if (props.column.field !== 'start') {
                let col =columnNames.filter(c=>c.field === props.column.field);
                if (col && col.length >0) {
                    setFormatType(col[0].filter);
                }
            }
            else {
                setFormatType('date');
            }
            setFormatList(JSON.parse(JSON.stringify(formats)));
            setFormatKey(props.column.field);
            setShowModal(true);
        };


        const clearColumnFormat =()=>{
            props.onCloseMenu();
            let format = formatObj;
            if (format[props.column.field]) {
                delete format[props.column.field];
            }
            setFormatObj(format);
            setFormatList([]);
        };

        const clearTableFormat =()=>{
            props.onCloseMenu();
            setFormatObj({});
            setFormatList([]);
        };

        const addCalculatedColumn = () => {
            setCurrentFormula(null);
            const colIndex = scoreGridRef.current._columns.find(c => c.field === props.column.field).orderIndex;
            if (!colIndex) {
                setFormulaColumnIndex(scoreGridRef.current._columns.length);
            }
            else {
                setFormulaColumnIndex(colIndex);
            }

            props.onCloseMenu();
            setFormulaCellModalOpen(true);
        };

        const editCalculatedColumn = () => {
            const editFormula = formulaColumns.find(f => f.fieldName === props.column.field);
            if (editFormula) {
                setCurrentFormula(editFormula);
                setFormulaCellModalOpen(true);
            }
            props.onCloseMenu();
        };

        const remomveCalculatedColumn = () => {
            const updatedColumns = columnNames.filter(c => c.field !== props.column.field);
            setColumnNames(updatedColumns);

            const updatedExportColumns = exportColumnNames.filter(c => c.field !== props.column.field);
            setExportColumnNames(updatedExportColumns);
            setFormulaGridColumns(updatedColumns);

            const currentFormulaList = _.cloneDeep(formulaColumns);
            const updatedColumnList = currentFormulaList.filter(c => c.fieldName !== props.column.field);
            setFormulaColumns(updatedColumnList);
            configuration.columns = updatedColumns;
            configuration.selectedFormulaColumns = updatedColumnList;
            setConfiguration(configuration);
            props.onCloseMenu();
        };

        return (
            <div>
                <div style={{width: 'auto'}} className={classes.BobActionMenuFormat}>
                    <button
                        onClick={createConditionalFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabindex="0"
                        type="button"
                    >
                        <span class="MuiButton-label">  <i className={`fa fa-plus ${ classes.BobActionMenuIcon }`} />Conditional Formatting</span>
                    </button>
                    <button
                        onClick={clearColumnFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabindex="0"
                        type="button"
                    >
                        <span class="MuiButton-label"><i className={`fas fa-redo-alt ${ classes.BobActionMenuIcon }`} />Clear Column Formatting</span>
                    </button>
                    <button
                        onClick={clearTableFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabindex="0"
                        type="button"
                    >
                        <span class="MuiButton-label"><i className={`fas fa-redo-alt ${ classes.BobActionMenuIcon }`} />Clear Table Formatting</span>
                    </button>
                    {
                        columnNames.filter(c => c.filter === 'numeric').length > 1 ?
                            <button
                                onClick={addCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${ classes.BobActionFormatItem }`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fas fa-columns ${ classes.BobActionMenuIcon }`} />Add Formula Column</span>
                            </button>
                            : null
                    }
                    {
                        props.isFormula ?
                            <button
                                onClick={editCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${ classes.BobActionFormatItem }`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fa fa-edit ${ classes.BobActionMenuIcon }`} />Edit Formula Column</span>
                            </button> : null
                    }
                    {
                        props.isFormula ?
                            <button
                                onClick={remomveCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fa fa-times ${ classes.BobActionMenuIcon }`} />Remove Formula Column</span>
                            </button>
                            : null
                    }
                </div>

            </div>
        );
    };

    const handleClose = () => {
        setShowModal(false);
    };

    //Ref - https://www.geeksforgeeks.org/interval-tree/
    class Interval
    {
        constructor()
        {
            this.low = 0;
            this.high = 0;
        }
    }

    class ITNode
    {
        // 'i' could also be a normal variable
        constructor()
        {
            this.max = 0;
            this.left = null;
            this.right = null;
            this.i = null;
        }
    }

    // A utility function to create a new node
    function newNodeDouble(l, h)
    {
        var temp = new Interval();
        temp.low = l;
        temp.high = h;
        return temp;
    }

    // A utility function to create a new node
    function newNodeSingle(i)
    {
        var temp = new ITNode();
        temp.i = i;
        temp.max = i.high;
        temp.left = temp.right = null;
        return temp;
    }

    // A utility function to insert a new
    // Interval Search Tree Node. This is
    // similar to BST Insert. Here the
    // low value of interval is used to
    // maintain BST property
    function insert(root, i)
    {

        // Base case: Tree is empty,
        // new node becomes root
        if (root == null)
            return newNodeSingle(i);

        // Get low value of interval at root
        var l = root.i.low;

        // If root's low value is smaller,
        // then new interval goes to left subtree
        if (i.low < l)
            root.left = insert(root.left, i);

        // Else, new node goes to right subtree.
        else
            root.right = insert(root.right, i);

        // Update the max value of this
        // ancestor if needed
        if (root.max < i.high)
            root.max = i.high;
        return root;
    }

    // A utility function to check if given
    // two intervals overlap
    function doOVerlap(i1, i2)
    {
        if (i1.low < i2.high && i2.low < i1.high)
            return true;
        return false;
    }

    // The main function that searches a given
    // interval i in a given Interval Tree.
    function overlapSearch(root, i)
    {

        // Base Case, tree is empty
        if (root == null)
            return null;

        // If given interval overlaps with root
        if (doOVerlap(root.i, i))
            return root.i;

        // If left child of root is present
        // and max of left child is greater
        // than or equal to given interval,
        // then i may overlap with an interval
        // is left subtree
        if (root.left != null &&
       root.left.max >= i.low)
            return overlapSearch(root.left, i);

        // Else interval can only
        // overlap with right subtree
        return overlapSearch(root.right, i);
    }

    // This function prints all conflicting
    // appointments in a given array of apointments.
    function printConflicting(appt, n)
    {

        // Create an empty Interval Search
        // Tree, add first appointment
        var root = null;
        root = insert(root, appt[0]);

        // Process rest of the intervals
        for (var i = 1; i < n; i++)
        {

            // If current appointment conflicts
            // with any of the existing intervals,
            // print it
            var res = overlapSearch(root, appt[i]);

            if (res != null) {
                appt[i].conflicted = true;
                res.conflicted = true;
            }
            // Insert this appointment
            root = insert(root, appt[i]);
        }
    }

    const validateConditions = ()=>{
        const intervals =[];
        formatList.forEach(c => {
            if (c.operator === 'Greater Than') {
                intervals.push(newNodeDouble(c.field1,Number.MAX_SAFE_INTEGER));
            }
            else  if (c.operator === 'Less Than') {
                intervals.push(newNodeDouble(0,c.field1));
            }
            else  if (c.operator === 'Between') {
                intervals.push(newNodeDouble(c.field1,c.field2));
            }
            else  if (c.operator === 'Equals') {
                intervals.push(newNodeDouble(c.field1,c.field1));
            }
        });
        printConflicting(intervals, intervals.length);
        return intervals;
    };

    const handleSubmit = (data,key) =>{
        if (formatType === 'numeric') {
            let gaps = validateConditions();
            let formatlist = formatList;
            let conflict = false;
            gaps.forEach((c,i)=>{
                formatlist[i].conflicted = c.conflicted?true:false;
                if (c.conflicted)
                    conflict = true;
            });
            if (conflict) {
                setFormatList([...formatlist]);
                return false;
            }
        }
        let obj = formatObj;
        obj[formatKey] = JSON.parse(JSON.stringify(formatList));
        setConfiguration({ ...configuration, conditionalFormat: obj });
        setFormatObj(obj);
        setColumnNames([...columnNames]);
        return true;
    };

    const updateFormat = (data,i,key) =>{
        let formatlist = formatList && formatList.length>0?formatList:[];
        if (formatlist[i]) {
            formatlist[i][key] = data;
        }
        else {
            let obj = {};
            obj[key] = data;
            formatlist.push(obj);
        }
        setFormatList([...formatlist]);
    };

    const addItem = ()=>{
        let formatlist = formatList && formatList.length>0?formatList:[];
        formatlist.push({'operator': '','condition': ''});
        setFormatList([...formatlist]);
    };

    const removeItem = (index) =>{
        let formatlist = formatList && formatList.length>0?formatList:[];
        formatlist.splice(index,1);
        setFormatList([...formatlist]);
    };

    const ruleClick = async dataItem => {
        if (selectedRule.ruleId === dataItem.ruleId) {
            return;
        }
        setSelectedRule({});
        setSelectedRuleFromFaultsPage({});
        // configuration changes
        setActiveConfiguration({});
        // this is only for score grid
        setFormatObj({});
        const columns = columnNames.filter(c => c.field === 'start');
        setColumnNames(columns);

        setSelectedWeatherSensors([]);

        let ruleIds = [dataItem.ruleId];

        if (!_.isEqual(selectedRule, dataItem)) {
            scoreGridDataState.filter = initialDataStateFilter;
            setScoreGridDataState(scoreGridDataState);
        }

        let weatherSensors = '';

        let ruleSensors = [];

        let currentConfig = ruleScoringConfig;
        let promises = [];

        // This block of code manages the rule config storage
        // We look to see if we have a current configuration
        if (!_.isEmpty(currentConfig.current)) {

            // If we have a current config we check to see if the current config is the rule selected
            if (ruleScoringConfig.current.ruleId === ruleIds[0]) {

                // If so we just fetch the scoring data from the current configuration
                const rules = ruleScoringConfig.current.ruleId;
                const sensorIds = ruleScoringConfig.current.sensorIds;
                setSelectedRuleSensors(sensorIds);
                ruleSensors = sensorIds;

                if (!_.isEmpty(sensorIds)) {
                    promises.push(fetchEntitySensorData(sensorIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, sensorIds, [rules], dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));

            // We check if the rule selected is one of the previous configurations
            } else if (ruleScoringConfig.previous.find(config => config.ruleId === ruleIds[0])) {

                // If so, we use the sensors from that configuration, set it as the new current, and remove it from the previous array.
                const existingRule = currentConfig.previous.find(config => config.ruleId === ruleIds[0]);
                const currentRule = currentConfig.current;

                currentConfig.previous.push(currentRule);
                currentConfig.previous = currentConfig.previous.filter(item => item.ruleId !== ruleIds[0]);

                currentConfig.current = {
                    ruleId:           ruleIds[0],
                    sensorIds:        existingRule.sensorIds,
                    ruleSensorIds:    existingRule.ruleSensorIds,
                    wehaterSensorIds: existingRule.weatherSensorIds
                };
                setSelectedRuleSensors(existingRule.sensorIds);
                setRuleScoringConfiguration(currentConfig);
                ruleSensors = existingRule.sensorIds;

                if (!_.isEmpty(existingRule.sensorIds)) {
                    promises.push(fetchEntitySensorData(existingRule.sensorIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, existingRule.sensorIds, ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));

            // This scenario is what happens when we have a current configuration but select a new rule.
            } else {
                const ids = await fetchSensorIds(queryValues.site, queryValues.equipment, ruleIds);
                const currentRule = currentConfig.current;
                currentConfig.previous.push(currentRule);
                ruleSensors = ids;

                currentConfig.current = {
                    ruleId:           ruleIds[0],
                    sensorIds:        ids,
                    ruleSensorIds:    ids,
                    weatherSensorIds: weatherSensors
                };
                setSelectedRuleSensors(ruleSensors);
                setRuleScoringConfiguration(currentConfig);

                if (!_.isEmpty(ids)) {
                    promises.push(fetchEntitySensorData(ids, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
                } else {
                    clearEntitySensorData();
                }
                promises.push(fetchScoringData(queryValues.company, [], ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));
            }

        // This scenario is what happens when there has been no current configuration, initial load.
        } else {
            const ids = await fetchSensorIds(queryValues.site, queryValues.equipment, ruleIds);
            ruleSensors = ids;

            currentConfig.current = {
                ruleId:           ruleIds[0],
                sensorIds:        ids,
                ruleSensorIds:    ids,
                weatherSensorIds: weatherSensors
            };
            setSelectedRuleSensors(ids);
            if (!_.isEmpty(ids)) {
                promises.push(fetchEntitySensorData(ids, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId: queryValues.equipment, weatherSensors }));
            } else {
                clearEntitySensorData();
            }
            promises.push(fetchScoringData(queryValues.company, [], ruleIds, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: queryValues.equipment, weatherSensors }));
        }

        let updateConfiguration = _.cloneDeep(configuration);
        updateConfiguration.selectedRule = dataItem;
        updateConfiguration.selectedSensors = ruleSensors;
        setConfiguration(updateConfiguration);

        setSelectedRule({ ...dataItem, sensorIds: ruleSensors });

        await Promise.all(promises.map(p => p.catch(err => err)));
    };

    // onClick of rule name from Equipment Faults page will redirect to Equipment Score grid page
    useEffect(() => {
        if (!_.isEmpty(ruleScoreKpis) && !_.isEmpty(selectedRuleFromFaultsPage)) {
            const selectedRuleItem = ruleScoreKpis.filter(ruleKpi => ruleKpi.ruleId === selectedRuleFromFaultsPage.ruleId);
            ruleClick(selectedRuleItem[0]);
        }
    }, [selectedRuleFromFaultsPage, ruleScoreKpis]);

    const ruleNameCell = props => {
        const { dataItem, field } = props;
        const linkPath = `/rules/${dataItem.ruleId}/edit/properties?company=${activeNavCompany.id}`;

        return (
            <td className={selectedRule.ruleId === dataItem.ruleId ? classes.SelectedNameCell : classes.NameCell} role="none">
                <Link
                    to={linkPath}
                    target="_blank"
                >
                    {dataItem[field]}
                </Link>
            </td>
        );
    };

    const onColumnReorder = e => {
        const orderedColumns = e.columns.sort((a, b) => a.orderIndex - b.orderIndex).map((column, index) => {
            return {
                name:       column.title,
                field:      column.field,
                filter:     column.filter,
                locked:     column.locked ? column.locked : false,
                fault:      column.fault,
                orderIndex: index
            };
        });
        setExportColumnNames(orderedColumns);
        setConfiguration({ ...configuration, columns: orderedColumns });
    };

    const valueHeaderCell = (props) => {
        if (props.field) {
            const headerValue = props.field.startsWith('ruleName') ? `Rule - ${props.title}` : props.field === 'ruleFvo' ? 'Formula Value Output' : props.field.startsWith('sensor') ? props.title.startsWith('*') ? props.title : `*${props.title}` : props.title !== null ? props.title : 'Uknown Sensor';
            return (
                <HtmlTooltip
                    title={
                        <span className={classes.Tooltip}>
                            {props.title}
                        </span>
                    }
                    placement="top"
                >
                    <span className="k-cell-inner">
                        <span className="k-link" onClick={props.onClick}>
                            <span title={props.title}>{headerValue}</span>
                            {props.children}
                        </span>
                        <GridColumnMenuWrapper
                            {...props.columnMenuWrapperProps}
                        />
                    </span>
                </HtmlTooltip>
            );
        }
        else {
            return '';
        }
    };

    const faultCell = props => {
        const title = buildFvoTooltip(props.dataItem);
        const className = `material-symbols-outlined ${props.dataItem[props.field] ? 'red' : 'green'}-status`;
        const icon = props.dataItem[props.field] ? 'warning' : 'task_alt';
        return (
            <HtmlTooltip
                title={title}
                placement="top-start"
            >
                <td className={props.className} style={props.style}>
                    <span className={className}>
                        {icon}
                    </span>
                </td>

            </HtmlTooltip>
        );
    };

    const replaceSensorTypeIdWithName = (formula, sensorFilters, useValues, props) => {
        
        // don't need to show any of the comments that come before the formula itself
        if (formula === null || formula === undefined) {
            return '';
        }

        const returnLocation = formula.toLowerCase().indexOf('return');
        let parsedFormula = returnLocation === 0 ? formula : formula.substring(returnLocation);

        const split = parsedFormula.split(' ');

        split.forEach((item, index) => {
            if (item.includes('sensors[')) {
                const id = item.match(/"(.*?)"/g) || item.match(/'(.*?)'/g);
                const selectedId = id[0].replaceAll('"', '').replaceAll('\'', '');
                const sensor = sensorFilters.find(sensor => sensor.id === selectedId);

                if (sensor) {
                    let replacementValue = sensor.sensorTypeName;
                    if (useValues) {
                        if (!_.isNaN(props[`ruleFvoSensorVal_${selectedId}`])) {
                            replacementValue = Math.round(_.toNumber(props[`ruleFvoSensorVal_${selectedId}`] * 10000) / 10000);
                        }
                        else {
                            replacementValue = replacementValue = props[`ruleFvoSensorVal_${selectedId}`];
                        }
                        
                    }
                    parsedFormula = parsedFormula.replace(`sensors['${sensor.id}']`, replacementValue);
                }
            }
        });

        return parsedFormula.replace('return ', '');
    };

    const buildFvoTooltip = props => {
        let formattedFaultCode;
        let faultCodeTooltipText;
        let formattedFormulaCode;
        let formattedFormulaValue;
        let formulaCodeTooltipText;
        let ruleAggregateTooltip;
        let sensorTypesTooltip;

        const {
            faultCode, 
            formulaCode,
            ruleAggregateCount, 
            ruleAggregateDuration, 
            ruleAggregateType, 
            sensorFilters
        } = ruleInfo;

        if (faultCode) {
            formattedFaultCode = replaceSensorTypeIdWithName(faultCode, sensorFilters);
            if (formattedFaultCode.includes('fvo')) {
                let fvoValue = props.ruleFvo;
                if (fvoValue?.toLowerCase() !== 'true' && fvoValue?.toLowerCase() !== 'false') {
                    fvoValue = Math.round(props.ruleFvo * 10000) / 10000;
                }
                formattedFaultCode = formattedFaultCode.replace('fvo', fvoValue);
            }

            faultCodeTooltipText = 
                <div>
                    <div>Fault Logic:</div>
                    <div className={classes.FaultTooltipItem} style={{color: 'blue'}}>{formattedFaultCode}</div>
                </div>
            ;
        }

        if (formulaCode) {
            formattedFormulaCode = replaceSensorTypeIdWithName(formulaCode, sensorFilters);
            formattedFormulaValue = replaceSensorTypeIdWithName(formulaCode, sensorFilters, true, props);

            let fvoValue = props.ruleFvo;
            if (fvoValue?.toLowerCase() !== 'true' && fvoValue?.toLowerCase() !== 'false') {
                fvoValue = Math.round(props.ruleFvo * 10000) / 10000;
            }

            formulaCodeTooltipText = 
                <div>
                    <div>Formula Code:</div>
                    <div className={classes.FaultTooltipItem}>{formattedFormulaCode}</div>
                    <div className={classes.FaultTooltipItem} style={{color: 'blue'}}>{formattedFormulaValue} = {fvoValue}</div>
                </div>
            ;
        }
        
        if (ruleAggregateType?.toLowerCase() !== 'none') {
            ruleAggregateTooltip =
                <div>
                    <div>Rule Aggregate:</div>
                    <div className={classes.FaultTooltipItem}>Type: {ruleAggregateType}</div>
                    <div className={classes.FaultTooltipItem}>Duration: {ruleAggregateDuration} - Count: {ruleAggregateCount}</div>
                </div>;
        }
        else {
            ruleAggregateTooltip = 
                <div>
                    <div>Rule Aggregate:</div>
                    <div className={classes.FaultTooltipItem}>Type: {ruleAggregateType}</div>
                </div>;
        }

        if (sensorFilters) {
            sensorTypesTooltip = 
                <div>
                    <div>Sensor Aggregates:</div>
                    {
                        sensorFilters.map(sensor => 
                            <React.Fragment>
                                <div className={classes.FaultTooltipItem}>Sensor: {sensor.sensorTypeName}</div>
                                <div className={classes.FaultTooltipItem}>Type: {sensor.sensorAggregateType}{sensor.sensorAggregateType?.toLowerCase() !== 'none' ? ` - Duration: ${sensor.sensorAggregateDuration}`: ''}</div>
                            </React.Fragment>
                        )
                    }
                </div>;
        }

        const tooltip = (
            <React.Fragment>
                {formulaCodeTooltipText?.length !== 0 ? formulaCodeTooltipText : null}
                {faultCodeTooltipText?.length !== 0 ? faultCodeTooltipText : null}
                {ruleAggregateTooltip?.length !== 0 ? ruleAggregateTooltip : null}
                {sensorTypesTooltip?.length !== 0 ? sensorTypesTooltip : null}
            </React.Fragment>    
        );
        return tooltip;
    };

    const onRuleGridDataStateChange = e => {
        setRuleGridDataState(e.dataState);
    };

    const onScoreGridDataStateChange = e => {
        if (activeConfiguration && activeConfiguration.viewData) {
            if (e.dataState.filter !== activeConfiguration.viewData.filter) {
                setConfiguration({...configuration, filter: e.dataState.filter});
            }
        }
        setScoreGridDataState(e.dataState);
    };

    const aggregateFooterCell = props => {
        const field = props.field || '';
        const filteredData = _.cloneDeep(kendoProcess(scoringData, scoreGridDataState));
        const column = scoreGridRef?.current?._columns.find(c => c.field === field);
        const columnType = column?.filter;
        let isRuntimeColumn = false;
        if (column && column.title.toLowerCase().includes('runtime') && aggregateType === 'Runtime') {
            isRuntimeColumn = true;
        }

        return (
            <SensorScoreAggregateFooterCell
                aggregateType={aggregateType}
                className={props.className}
                colSpan={props.colSpan}
                columnType={columnType}
                excelExport={false}
                filteredData={filteredData}
                field={field}
                style={props.style}
                isRuntimeColumn={isRuntimeColumn}
            />
        );
    };

    const ExcelExportFooterCell = props => {
        const field = props.column.field || '';
        const filteredData = _.cloneDeep(kendoProcess(scoringData, scoreGridDataState));
        const column = scoreGridRef?.current?._columns.find(c => c.field === field);
        const columnType = column?.filter;
        let isRuntimeColumn = false;
        if (column && column.title.toLowerCase().includes('runtime') && aggregateType === 'Runtime') {
            isRuntimeColumn = true;
        }

        return (
            <SensorScoreAggregateFooterCell
                aggregateType={aggregateType}
                columnType={columnType}
                excelExport={true}
                filteredData={filteredData}
                field={field}
                isRuntimeColumn={isRuntimeColumn}
            />
        );
    };

    const BuildFaultCellFilterCell = props => {
        return FaultCellFilter(props, selectedBooleanFilter, setSelectedBooleanFilter);
    };

    const onRuleGridRowClick = e => {
        ruleClick(e.dataItem);
    };

    const clearRuleGridFilter = filter => {
        setRuleGridDataState({...ruleGridDataState, filter: filter ? filter : initialDataStateFilter});
    };

    const clearScoreGridFilter = filter => {
        setScoreGridDataState({...scoreGridDataState, filter: filter ? filter : initialDataStateFilter});
    };

    return (
        <div className={classes.ScoreGrid}>
            <div className={classes.TableContainer}>
                <style>
                    { kendoGridInlineStyling }
                    {
                        `.k-toolbar {
                             order: 1;
                             border-top: inset 1px rgba(0, 0, 0, 0.12);
                             max-height: 5.8rem;
                        }`
                    }
                </style>
                <Grid
                    style={{
                        width:  '20%',
                        margin: '0'
                    }}
                    className={classes.KendoGrid}
                    filterable={workbookModeEnabled}
                    sortable
                    data={kendoProcess(ruleScoreKpis, ruleGridDataState)}
                    {...ruleGridDataState}
                    onDataStateChange={onRuleGridDataStateChange}
                    onRowClick={onRuleGridRowClick}
                >
                    {
                        workbookModeEnabled ?
                            <GridToolbar>
                                <FilterPanel
                                    title={'Rule Filter Builder'}
                                    filter={ruleGridDataState.filter}
                                    filterText={ruleGridFilterText}
                                    fields={ruleGridFields}
                                    columns={[{name: 'Rule', field: 'ruleName', filter: 'text'}, {name: 'Score', field: 'score', filter: 'numeric'}]}
                                    setFilter={clearRuleGridFilter}
                                    setFilterText={setRuleGridFilterText}
                                />
                            </GridToolbar>
                            : null
                    }
                    {
                        bobLoading.includes('RuleKpi') ?
                            <GridNoRecords>
                                Loading rules
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column
                        field="ruleName"
                        key="ruleId"
                        title="Rule"
                        cell={ruleNameCell}
                        filter={'text'}
                    />
                    <Column
                        field="score"
                        key="score"
                        title="Score"
                        cell={ruleScoreCell}
                        filter={'numeric'}
                    />
                </Grid>
                <ExcelExport data={filterBy(scoringData, scoreGridDataState.filter)} ref={_export}>
                    {
                        exportColumnNames.map((column, index) => (
                            <ExcelExportColumn
                                key={index}
                                field={column.field}
                                title={column.name}
                                filter={column.filter}
                                locked={column.locked ? column.locked : false}
                                footer={aggregateType !== 'None' ? ExcelExportFooterCell : null}
                            />
                        ))
                    }
                </ExcelExport>
                {
                    _.isEmpty(selectedRule) ?
                        <NoSelectedSensorsScreen
                            style={{
                                width:      '80%',
                                margin:     '0',
                                marginLeft: '1rem'
                            }}
                            message="Please select a Rule from the panel to the left or the dropdown list above to load the data"
                            height={classes.KendoGrid.height}
                        />
                        :
                        <React.Fragment>
                            <style>
                                { kendoGridInlineStyling }
                                {
                                    `.k-toolbar {
                                         order: 1;
                                         border-top: inset 1px rgba(0, 0, 0, 0.12);
                                         max-height: 5.8rem;
                                    }`
                                }
                            </style>
                            <Grid
                                ref={scoreGridRef}
                                style={{
                                    width:      '80%',
                                    margin:     '0',
                                    marginLeft: '1rem'
                                }}
                                className={ classes.KendoGrid }
                                filterable={workbookModeEnabled}
                                reorderable={true}
                                sortable
                                data={kendoProcess(scoringData, scoreGridDataState)}
                                {...scoreGridDataState}
                                onDataStateChange={onScoreGridDataStateChange}
                                onColumnReorder={onColumnReorder}
                            >
                                {
                                    workbookModeEnabled ?
                                        <GridToolbar>
                                            <FilterPanel
                                                title={'Score Filter Builder'}
                                                filter={scoreGridDataState.filter}
                                                filterText={scoreGridFilterText}
                                                fields={scoreGridFields}
                                                columns={columnNames}
                                                setFilter={clearScoreGridFilter}
                                                setFilterText={setScoreGridFilterText}
                                            />
                                        </GridToolbar>
                                        : null
                                }
                                {
                                    bobLoading.includes('ScoreData') ?
                                        <GridNoRecords>
                                            Loading scores
                                        </GridNoRecords>
                                        :
                                        null
                                }
                                {
                                    columnNames.map((column, index) => (
                                        <Column
                                            key={index}
                                            reorderable={column.field !== 'start' && !column.fault}
                                            locked={column.field === 'start'}
                                            width={column.field === 'start' ? 225 : column.field === 'ruleFvo' ? 215 : column.fault ? 125 : 250}
                                            field={column.field}
                                            title={column.name}
                                            filter={column.filter}
                                            filterCell={column.fault ? BuildFaultCellFilterCell : null}
                                            headerCell={valueHeaderCell}
                                            columnMenu={(props) => (
                                                <ColumnMenu
                                                    {...props}
                                                    isFormula={column.isFormula ? column.isFormula : false}
                                                />
                                            )}
                                            cell={column.field === 'start' ? timeStampCell : column.fault ? faultCell : valueCell}
                                            footerCell={aggregateType !== 'None' ? aggregateFooterCell : null}
                                            fault={column.fault}
                                        />
                                    ))
                                }
                            </Grid>
                        </React.Fragment>
                }
            </div>
            {
                bobLoading.includes('ScoreData') || bobLoading.includes('SensorIds') || bobLoading.includes('RuleKpi') ?
                    <BobLoadingMask />
                    :
                    null
            }
            { showModal?
                <ConditionalFormatModal
                    open={showModal}
                    formatList ={formatList}
                    formatKey = {formatKey}
                    addItem={addItem}
                    removeItem={removeItem}
                    fieldType={formatType}
                    updateFormat={updateFormat}
                    submitFormat={handleSubmit}
                    close={handleClose}
                />:''
            }
            {
                formulaCellModalOpen ?
                    <FormulaGridColumnModal
                        cellIndex={formulaColumnIndex}
                        columnList={columnNames.filter(c => c.filter === 'numeric')}
                        formula={currentFormula}
                        setFormulaFormIsOpen={setFormulaCellModalOpen}
                        setFormulaValues={setFormulaValues}
                        title={currentFormula ? 'Edit Formula' : 'Create Formula'}
                    />
                    : null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:            state.bob.activeNavClient,
        activeNavCompany:           state.bob.activeNavCompany,
        activeNavEquipment:         state.bob.activeNavEquipment,
        activeNavSite:              state.bob.activeNavSite,
        bobLoading:                 state.bob.bobLoading,
        currentUser:                state.currentUser,
        dashboardEndTimeStamp:      state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp:    state.dashboard.dashboardStartTimeStamp,
        desiredInterval:            state.dashboard.desiredInterval,
        entityScoringData:          state.bob.entityScoringData,
        entityScoringDataMeta:      state.bob.entityScoringDataMeta,
        formulaGridColumns:         state.dashboard.formulaGridColumns,
        ruleScoreKpis:              state.dashboard.ruleScoreKpis,
        ruleScoringConfig:          state.dashboard.ruleScoringConfig,
        selectedRule:               state.dashboard.selectedRule,
        selectedRuleSensors:        state.dashboard.selectedRuleSensors,
        selectedRuleFromFaultsPage: state.dashboard.selectedRuleFromFaultsPage,
        selectedWeatherSensors:     state.dashboard.selectedWeatherSensors,
        workbookModeEnabled:        state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScoreGrid));
